import React, { PureComponent } from 'react'
import { Typography, TextField, Button, Dialog, Paper, CircularProgress } from '@material-ui/core'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import { Grid, AutoSizer } from 'react-virtualized'
import _ from 'lodash'

import 'react-virtualized/styles.css'

import icons from './icons'

class IconPicker extends PureComponent {
  state = { searching: false, modal: false, results: icons, query: '' }
  componentDidMount() {
    if (this.props.icon === null) {
      this.getIcon(icons.find(i => i.id === 1214239))
    }
  }
  toggle = (modal = !this.state.modal) => {
    this.setState({
      modal
    })
  }
  onChange = e => {
    this.setState(
      {
        query: e.target.value,
        searching: true
      },
      () => {
        this.filter()
      }
    )
  }
  filter = _.debounce(() => {
    const results = icons.filter(i => {
      return i.tags.filter(tag => {
        return tag.toLowerCase().includes(this.state.query.toLowerCase())
      }).length
    })
    this.setState({
      searching: false,
      results
    })
  }, 1000)
  getGridListCols = () => {
    if (isWidthUp('md', this.props.width)) {
      return 10
    }
    if (isWidthUp('sm', this.props.width)) {
      return 8
    }
    return 4
  }
  getIcon = icon => {
    let image = new Image()
    let updateIcon = this.props.updateIcon
    let toggle = this.toggle
    image.onload = function() {
      let canvas = document.createElement('canvas')
      canvas.width = this.naturalWidth
      canvas.height = this.naturalHeight
      canvas.getContext('2d').drawImage(this, 0, 0)

      updateIcon(canvas.toDataURL('image/png'))
      toggle(false)
    }
    image.src = require(`./${icon.svg}`)
  }
  cellRenderer = ({ columnIndex, rowIndex, key, style }) => {
    const icon = this.state.results[rowIndex * this.getGridListCols() + columnIndex]
    if (icon) {
      return (
        <div style={style} className={`icon-picker-image`} onClick={() => this.getIcon(icon)} key={key}>
          <img src={require(`./${icon.svg}`)} alt="" />
        </div>
      )
    } else {
      return null
    }
  }
  render() {
    console.log(Math.ceil(this.state.results.length / this.getGridListCols()))
    return (
      <div style={{ marginRight: 24, marginTop: 24 }}>
        <Typography variant="h6" gutterBottom>
          Icon
        </Typography>
        <div
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 24,
            borderRadius: 4,
            height: 150,
            width: '100%',
            minWidth: 200,
            maxWidth: 300,
            backgroundColor: '#f2f2f2'
          }}
        >
          <img src={`${this.props.icon}`} alt="" style={{ width: 50, height: 50, marginBottom: 16, opacity: 0.75 }} />
          <Button onClick={() => this.toggle()} variant="contained">
            Select
          </Button>
        </div>
        <Dialog maxWidth={'sm'} fullWidth open={this.state.modal} onClose={() => this.toggle()}>
          <Paper className="icon-picker">
            <TextField
              variant="outlined"
              autoFocus
              label="Search for Icon"
              onChange={this.onChange}
              value={this.state.query}
              fullWidth
              type="search"
            />
            {this.state.searching ? (
              <CircularProgress size={20} thickness={6} style={{ position: 'absolute', right: 40, top: 40 }} />
            ) : null}
            <div style={{ height: 24 }} />
            <div className="icon-picker-grid">
              <AutoSizer>
                {({ height, width }) => (
                  <Grid
                    cellRenderer={this.cellRenderer}
                    columnCount={this.getGridListCols()}
                    columnWidth={width / this.getGridListCols()}
                    height={height}
                    rowCount={
                      Math.ceil(this.state.results.length / this.getGridListCols()) <= 0
                        ? 1
                        : Math.ceil(this.state.results.length / this.getGridListCols())
                    }
                    rowHeight={width / this.getGridListCols()}
                    width={width}
                  />
                )}
              </AutoSizer>
            </div>
          </Paper>
        </Dialog>
      </div>
    )
  }
}

export default withWidth()(IconPicker)
